import script from "./CommonForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./CommonForm.vue?vue&type=script&lang=ts&setup=true"

import "./CommonForm.vue?vue&type=style&index=0&id=7949c7b2&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7949c7b2"]])

export default __exports__